<template>
  <div class="page-home">
    <div class="mod-header">
      <div class="mod-box clearfix">
        <a href="/"><img class="logo" src="../assets/images/logo.png" /></a>
        <div class="welcome">
          &ensp; 欢迎来到纵购！&ensp;
          <span v-if="user.username">
            <i class="user"></i>
            {{ user.linkman_name || user.username }}&ensp;
            <span class="logout" @click="onLogout">[ 退出 ]</span>
          </span>
          <span v-else>
            请&ensp;
            <a href="/login" class="logout">[登录]</a>&ensp;
            <a href="/register" class="logout">[免费注册]</a>
          </span>
        </div>
        <z-nav />
      </div>
    </div>
    <div class="mod-bg-1"></div>
    <div class="mod-bg-2"></div>
    <div class="mod-bg-3"></div>
    <div class="mod-bg-4"></div>
    <div class="mod-bg-5"></div>
    <div class="mod-bg-6">做五金建材生意，就用 纵购商城 系统！</div>
    <div class="mod-footer">
      <com-copyright />
    </div>
  </div>
</template>

<script>
import ComCopyright from '@/components/com-copyright'
import { logout } from '@/data'
import { syncToken, getUser, removeAccessToken } from '@/utils'
export default {
  name: 'Home',
  components: {
    ComCopyright
  },
  data() {
    return {
      user: getUser() || {}
    }
  },
  methods: {
    async onLogout() {
      await logout
      removeAccessToken('token')
      syncToken()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="postcss">
.page-home {
  .mod-header {
    background-color: #fabe00;
    height: 100px;
    padding: 16px 0;
    border-bottom: 3px solid #4b4a48;
    color: #4b4a48;
    a {
      color: #333;
    }
    .logo {
      float: left;
      width: 140px;
      margin-left: 10px;
      color: #4b4a48;
    }
    .welcome {
      float: left;
      padding: 44px 0 0 10px;
      line-height: 20px;
      color: #4b4a48;
      .logout {
        cursor: pointer;
        color: #4b4a48;
      }
      .user {
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url(../assets/images/icon-user.png) no-repeat;
        vertical-align: -3px;
      }
    }
  }

  .mod-bg-1 {
    height: 480px;
    background: url(../assets/images/bg-home-1.png) no-repeat center;
  }

  .mod-bg-2 {
    height: 560px;
    background: url(../assets/images/bg-home-2.png) #fdf9f8 no-repeat center;
  }

  .mod-bg-3 {
    height: 600px;
    background: url(../assets/images/bg-home-3.png) no-repeat center;
  }

  .mod-bg-4 {
    height: 560px;
    background: url(../assets/images/bg-home-4.jpg) no-repeat center;
  }

  .mod-bg-5 {
    height: 560px;
    background: url(../assets/images/bg-home-5.png) #ecfafb no-repeat center;
  }

  .mod-bg-6 {
    font-family: '微软雅黑 Oblique', '微软雅黑';
    font-style: oblique;
    font-size: 39px;
    color: #fff;
    text-align: center;
    height: 100px;
    line-height: 100px;
    background: url(../assets/images/bg-home-6.png) no-repeat center;
    background-size: auto 100px;
  }

  .mod-footer {
    height: 280px;
    background-color: #666;
    padding-top: 70px;
  }
}
</style>
